<template>
  <div>
    <el-row style="margin-bottom: 15px">
      <el-col align="right">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList" :height="height">
      <el-table-column label="联系人姓名" min-width="90" align="center" prop="name">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toDetail(scope.row)">{{scope.row.name}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="角色" min-width="130" align="center" prop="businessRole" />
      <el-table-column label="部门" min-width="130" align="center" prop="apartment" />
      <el-table-column label="职务" min-width="100" align="center" prop="position" />
      <el-table-column label="手机号" min-width="130" align="center" prop="mobile" >
        <template slot-scope="scope">
          <el-button type="text" title="点击获取完整手机号" v-if="scope.row.mobile.indexOf('**')>=0"
                     @click="queryMobile(scope.row)">{{ scope.row.mobile }}</el-button>
          <span v-else>{{ scope.row.mobile }}</span>
        </template>
      </el-table-column>
      <el-table-column label="立场" min-width="80" align="center" prop="standScore" />
    </el-table>
    <AddContactDialog ref="addContactDialogRef" @success="queryList"></AddContactDialog>
  </div>
</template>

<script>

import {queryContactByCustomerId, queryMobile} from "@/api/crm/contact";
import AddContactDialog from "@/views/crm/contact/addContactDialog";

export default {
  name: "CustomerContactList",
  props: {
    customerId: {},
    paramData: {
      type: Object,
      default: {}
    },
    height: {
      type: String,
      default () {
        return "250"
      }
    }
  },
  data() {
    return {
      loading: false,
      dataList: []
    };
  },
  created() {
    if (this.customerId) {
      this.queryList();
    }
  },
  components: {
    AddContactDialog
  },
  watch: {
    customerId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    }
  },
  methods: {
    /** 新增按钮操作 */
    handleAdd() {
      this.$refs.addContactDialogRef.open('customerId', this.customerId, this.paramData.customerName);
    },
    queryList () {
      this.loading = true;
      queryContactByCustomerId({customerId: this.customerId}).then(response => {
        this.dataList = response.data || [];
        this.$emit('after-query', this.dataList);
        this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/contact/detail/" + row.id, "_blank")
    },
    queryMobile(row){
      const loading = this.$loading({lock: true, text: '查询中', spinner: 'el-icon-loading'});
      queryMobile({
        id: row.id
      }).then(response => {
        if (response.data) {
          row.mobile = response.data
        }
      }).finally(error => {
        loading.close()
      })
    }
  }
};
</script>
